<script>
import { mapGetters } from 'vuex';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  setup() {
    const { getPlainText } = useMessageFormatter();
    return { getPlainText };
  },
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        shortCodeLabel: `/${cannedMessage.short_code}`,
        attachments: cannedMessage.attachments || [],
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', {
        content: item.description,
        attachments: item.attachments || [],
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  >
    <template #default="{ item, selected }">
      <p
        class="max-w-full min-w-0 mb-0 overflow-hidden text-sm font-medium text-n-slate-11 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap"
        :class="{ 'text-n-slate-12': selected }"
      >
        {{ getPlainText(item.description) }}
      </p>
      <div class="flex items-center gap-2 max-w-full min-w-0">
        <p
          class="min-w-0 mb-0 overflow-hidden text-xs text-n-slate-11 group-hover:text-n-slate-12 text-ellipsis whitespace-nowrap"
          :class="{ 'text-n-slate-12': selected }"
        >
          {{ item.shortCodeLabel }}
        </p>
        <span
          v-if="item.attachments.length"
          class="flex items-center gap-0.5 text-xs shrink-0 text-n-slate-11"
        >
          <span class="i-ri-attachment-2" />
          {{ item.attachments.length }}
        </span>
      </div>
    </template>
  </MentionBox>
</template>
